<template>
  <div class="outermost">
    <div class="formbox">
      <el-form :inline="true">
        <el-form-item :label="$t('gdmap.addr')" style="width:500px">
          <el-select
              style="width: 450px"
              v-model="addressLocation"
              filterable
              remote
              :placeholder="$t('gdmap.pla')"
              :remote-method="change"
              :disabled="!isEdit"
          >
            <div v-for="item in addressOptions" :key="item.id">
              <el-option
                  :label="item.name"
                  :value="item.location.lng+','+item.location.lat"
                  @click.native="selectAddress(item)"
              >
                <div>
                  <div style="float: left">{{ item.name }}</div>
                  <div class="district">{{ item.description }}</div>
                </div>
              </el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('gdmap.lgd')" style="width:200px">
          <el-input style="width:140px" v-model="latitudeAndLongitude.longitude" readonly>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('gdmap.ltd')" style="width:200px">
          <el-input style="width:140px" v-model="latitudeAndLongitude.latitude" readonly>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div id="container"></div>
    <span v-show="isEdit" slot="footer" class="dialog-footer"
          style="float: right;padding-right: 40px;margin-top: 20px;">
                <el-button @click="cancel">{{$t("common.btnUsual")}}</el-button>
                <el-button type="primary" @click="transferLngLAt">{{$t("common.btnPrimary")}}</el-button>
    </span>
  </div>

</template>
<!--
         ****使用说明
         ***FatherLngLat的格式为字符串类型
            经度,纬度  例如  "118.17358,39.635334"
         ***子组件传值给父组件
            @transferFromGdMap='setUpLngLat'
            通过@transferFromGdMap事件使用setUpLngLat(mapData)方法接收返回值，
            mapData为对象类型，格式如下
            let mapData={
            lngLat:this.latitudeAndLongitude.longitude + ',' + this.latitudeAndLongitude.latitude,
            address:addressLocation
            }
            LngLat值的格式为字符串类型 例如"118.17358,39.635334"
            address为地址
         ***父组件传值给子组件
            v-bind:FatherLngLat="FatherLngLat"
            在data中初始化FatherLngLat的值，动态修改FatherLngLat即可
         ***:key="timer"
         使用this.timer = new Date().getTime();动态修改timer的值，保证每次可以重新加载子组件
-->

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import {$http} from "@/config/api/axios";

export default {
  data() {
    return {
      //经纬度对应的位置名称
      addressLocation: '',
      map: null,
      //标记
      marker: null,
      //地理位置选项
      addressOptions: [],
      //经纬度
      latitudeAndLongitude: {
        latitude: '',
        longitude: ''
      }
      //父组件传进的经纬度
    }
  },
  //接收父组件传的值
  props: {
    FatherLngLat: null,
    areaName: '',
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    var _this = this;
    let mapStyle;
    //mapStyle
    //判断主题
    let theme = localStorage.getItem('echartsTheme');
    if (theme == "theme1") {
      mapStyle = "amap://styles/c7a28a150b338ac28b82d6fd2d7e1c76";
    }
    if (theme == "theme2") {
      mapStyle = "amap://styles/0e1141547bf9461c3d8ce9ad0fe21f8d";
    }
    AMapLoader.load({
      key: '27f468aa704a39be18f457d04c0b501b',//首次load必填
      version: '2.0',
      plugins: ['AMap.Geocoder', 'AMap.DistrictSearch', 'AMap.Geolocation']
    }).then((AMap) => {
      _this.map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 13,
        projection: "EPSG:3857",
        mapStyle: mapStyle
      });
      if (_this.isEdit) {
        //绑定地图点击事件
        _this.map.on('click', this.showInfoClick);
        if (_this.FatherLngLat != null && _this.FatherLngLat != "") {
          var arr = _this.FatherLngLat.split(",");
          //修改坐标
          _this.latitudeAndLongitude.longitude = arr[0];
          _this.latitudeAndLongitude.latitude = arr[1];
          //修改地理位置名称
          var geocoder = new AMap.Geocoder();
          geocoder.getAddress([arr[0] * 1, arr[1] * 1], function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              _this.addressLocation = result.regeocode.formattedAddress;
            }
          })
          //平移地图
          _this.map.panTo([arr[0], arr[1]]);
          //添加点标记
          _this.addMarker(arr[0], arr[1])
        }
        if (_this.FatherLngLat == null || _this.FatherLngLat == "") {
          //行政区（省市区）查询
          var districtSearch = new AMap.DistrictSearch({
            // 返回行政区边界坐标等具体信息
            extensions: 'all',
            // 设置查询行政区级别为 区
            level: 'district'
          });
          if (this.areaName != null && this.areaName != '') {
            districtSearch.search(this.areaName, function (status, result) {
              if (status == "complete") {
                let lng = result.districtList[0].center.lng;
                let lat = result.districtList[0].center.lat;
                //修改地理位置名称
                var geocoder = new AMap.Geocoder();
                geocoder.getAddress([lng, lat], function (status, result) {
                  if (status === 'complete' && result.info === 'OK') {
                    _this.addressLocation = result.regeocode.formattedAddress;
                  }
                })
                //修改坐标
                _this.latitudeAndLongitude.longitude = lng;
                _this.latitudeAndLongitude.latitude = lat;
                //添加点标记
                _this.addMarker(lng, lat);
                _this.map.panTo([lng, lat]);

              }

            })
          } else {
            $http("get", "customerInfo/getLocation")
                .then((res) => {
                  if (res.status == "SUCCESS") {
                    if (res.data != null) {
                      let lat = res.data.latitude;
                      let lng = res.data.longitude;
                      //修改地理位置名称
                      var geocoder = new AMap.Geocoder();
                      geocoder.getAddress([lng, lat], function (status, result) {
                        if (status === 'complete' && result.info === 'OK') {
                          _this.addressLocation = result.regeocode.formattedAddress;
                        }
                      })
                      //修改坐标
                      _this.latitudeAndLongitude.longitude = lng;
                      _this.latitudeAndLongitude.latitude = lat;
                      //添加点标记
                      _this.addMarker(lng, lat);
                      _this.map.panTo([lng, lat]);
                    } else {
                      var geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,//是否使用高精度定位，默认:true
                        timeout: 10000,          //超过10秒后停止定位，默认：5s
                        buttonPosition: 'RB',    //定位按钮的停靠位置
                        buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                        zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点

                      });
                      //_this.map.addControl(geolocation);
                      geolocation.getCurrentPosition(function (status, result) {
                        if (status == 'complete') {
                          let lng = result.position.lng;
                          let lat = result.position.lat;
                          //修改地理位置名称
                          var geocoder = new AMap.Geocoder();
                          geocoder.getAddress([lng, lat], function (status, result) {
                            if (status === 'complete' && result.info === 'OK') {
                              _this.addressLocation = result.regeocode.formattedAddress;
                            }
                          })
                          //修改坐标
                          _this.latitudeAndLongitude.longitude = lng;
                          _this.latitudeAndLongitude.latitude = lat;
                          _this.addMarker(lng, lat);
                          _this.map.panTo([lng, lat]);
                        } else {

                        }
                      });
                    }
                  }
                })
          }
        }
      }else{

        if (_this.FatherLngLat != null && _this.FatherLngLat != "") {
          var arr = _this.FatherLngLat.split(",");
          if(arr[0]==null || arr[1]==null || arr[0]==="null" || arr[1]==="null"){
            _this.latitudeAndLongitude.longitude = "";
            _this.latitudeAndLongitude.latitude = "";
          }else{
            //修改坐标
            _this.latitudeAndLongitude.longitude = arr[0];
            _this.latitudeAndLongitude.latitude = arr[1];
            //修改地理位置名称
            var geocoder = new AMap.Geocoder();
            geocoder.getAddress([arr[0] * 1, arr[1] * 1], function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                _this.addressLocation = result.regeocode.formattedAddress;
              }
            })
            //平移地图
            _this.map.panTo([arr[0], arr[1]]);
            //添加点标记
            _this.addMarker(arr[0], arr[1])
          }
        }else{
          _this.latitudeAndLongitude.longitude = "";
          _this.latitudeAndLongitude.latitude = "";
        }
      }
        AMap.plugin('AMap.AutoComplete', function(){ // 高德2.0版本需要这样注册插件
            var autoOptions = {
                city: '全国'
            }
            _this.autoComplete = new AMap.Autocomplete(autoOptions);
        })
    });

  },
  created() {

  },
  watch: {},
  methods: {

    //向父组件传值
    transferLngLAt() {
      let mapData = {
        lngLat: this.latitudeAndLongitude.longitude + ',' + this.latitudeAndLongitude.latitude,
        address: this.addressLocation
      }
      if (this.latitudeAndLongitude.longitude == "" || this.latitudeAndLongitude.latitude == "") {
        mapData = {
          lngLat: "",
          address: ""
        }
      }
      this.$emit('transferFromGdMap', mapData)
    },
    cancel() {
      this.$emit('transferFromGdMap', null)
    },
    //地图点击事件
    showInfoClick(e) {
      var _this = this;
      var lng = e.lnglat.getLng();
      var lat = e.lnglat.getLat();
      _this.latitudeAndLongitude.longitude = lng;
      _this.latitudeAndLongitude.latitude = lat;
      _this.addMarker(lng, lat);
      var geocoder = new AMap.Geocoder();
      geocoder.getAddress([lng * 1, lat * 1], function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          _this.addressLocation = result.regeocode.formattedAddress;
        }
      })
    },
    //选择地理位置后
    selectAddress(item) {
      var _this = this;
      _this.addressLocation = item.name;
      //修改坐标
      _this.latitudeAndLongitude.longitude = item.location.lng;
      _this.latitudeAndLongitude.latitude = item.location.lat;
      //平移地图
      _this.map.panTo([item.location.lng, item.location.lat]);
      //添加点标记
      _this.addMarker(item.location.lng, item.location.lat)
    },
    //地理位置模糊检索
    change(query) {
      var _this = this;
      query = query.replace(/^\s+|\s+$/g, "");
      if (query == "" || query == null) {
        return;
      }
      let autoOptions = {
        city: '全国'
      }
      this.autoComplete.search(query, function (status, result) {
        if (status == "no_data") {
          return;
        }
        // 搜索成功时，result即是对应的匹配数据
        _this.addressOptions = [];
        for (let i = 0; i < result.tips.length; i++) {
          if (result.tips[i].location != null && result.tips[i].location != '' && result.tips [i].id != null && result.tips [i].id != '') {
            let address = new Object();
            address.name = result.tips[i].name;
            address.description = result.tips[i].district;
            address.location = result.tips[i].location;
            address.id = result.tips [i].id;
            _this.addressOptions.push(address);
          }
        }
      })
    },
    //添加点标记
    addMarker(lng, lat) {
      if (this.marker) {
        this.map.remove(this.marker);
      }
      this.marker = new AMap.Marker({
        position: new AMap.LngLat(lng * 1, lat * 1),
        offset: new AMap.Pixel(-13, -30)
      });
      this.map.add(this.marker);
    }
  }
}
</script>
<style lang="less">
#container {
  height: 400px;
  width: 960px
}

.outermost {
  width: 980px;
  height: 500px;
}

.district {
  float: left;
  margin-left: 10px;
  margin-right: 5px;
  color: #999;
  font-size: 13px;
}
.en-US{
    .outermost{
        .el-form {
            display: flex;
            .el-form-item{
                display: flex;
                .el-form-item__label{
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>